import axios from '@/request/http'
import global from '@/constants/Global.constants'

export default {
  findMemberLabel (params) { // 获取全部会员标签
    return axios.post(global.MMC_INFO + '/memberLabel/findMemberLabel', params)
  },
  findKnowledgeLabel (params) { // 获取知识库标签
    return axios.post(global.MMC_INFO + '/Knowledge/findKnowledgeLabel', params)
  },
  deleteKnowledge (params) { // 删除知识库
    return axios.post(global.MMC_INFO + '/Knowledge/deleteKnowledge', params)
  },
  insertKnowledge (params) { // 新增知识库
    return axios.post(global.MMC_INFO + '/Knowledge/insertKnowledge', params)
  },
  updateKnowledge (params) { // 修改知识库
    return axios.post(global.MMC_INFO + '/Knowledge/updateKnowledge', params)
  }
}
// global.MMC_INFO http://192.168.9.20:7001/msi/mmc/info



// WEBPACK FOOTER //
// ./src/request/mmc/knowledgeBase.js